const getCurrencyForPlaceHolder = ({ isFilterWithCurrency, currency, isFilterWithPercent }) => {
    if (isFilterWithCurrency) {
        return `(${currency})`;
    } else if (isFilterWithPercent) {
        return '%';
    }
    return '';
};

export const comparableFiltersPlaceholdersResolver = ({
    isFilterWithCurrency,
    isFilterWithPercent,
    showAdditionalInput,
    currency,
    formatMessage,
}) => {
    const placeholders = {};
    if (isFilterWithCurrency && !showAdditionalInput && !isFilterWithPercent) {
        placeholders.placeholder = currency;
    } else if (!isFilterWithCurrency && !showAdditionalInput && !isFilterWithPercent) {
        placeholders.placeholder = '0';
    } else if (!isFilterWithCurrency && !showAdditionalInput && isFilterWithPercent) {
        placeholders.placeholder = '%';
    } else {
        placeholders.placeholder = `${formatMessage({
            id: 'app.campaigns.reports.filters.input.placeholder.from',
            defaultMessage: 'From',
        })} ${getCurrencyForPlaceHolder({ isFilterWithCurrency, currency, isFilterWithPercent })}`;
        placeholders.additionalPlaceholder = `${formatMessage({
            id: 'app.campaigns.reports.filters.input.placeholder.to',
            defaultMessage: 'To',
        })} ${getCurrencyForPlaceHolder({ isFilterWithCurrency, currency, isFilterWithPercent })}`;
    }

    return placeholders;
};
